import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {Master} from '../../../../admin/models/master.interface';
import {IntelligenceSearchInterface} from '../../../models/intelligence-search.interface';
import {ActivatedRoute} from '@angular/router';
import {setFormValuesFromQueryParams} from '../../../utils/filters-utils';

@Component({
  selector: 'app-e-waste-legislation-filters',
  templateUrl: './e-waste-legislation-filters.component.html',
  styleUrls: ['./e-waste-legislation-filters.component.scss']
})
export class EWasteLegislationFiltersComponent implements OnInit {

  @Input()
  categories!: string[];

  searchForm = this.formBuilder.group({
    eWasteCategories: [''],
  });

  get categoriesControl(): FormControl {
    return this.searchForm.get('eWasteCategories') as FormControl;
  }

  @Output()
  search: EventEmitter<IntelligenceSearchInterface> = new EventEmitter<IntelligenceSearchInterface>();

  constructor(private formBuilder: FormBuilder,
              private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    setFormValuesFromQueryParams(this.searchForm, this.activatedRoute);
  }

  handleSubmit(): void {
    const search: IntelligenceSearchInterface = {
      year: 0,
      eWasteCategories: this.categoriesControl.value,
    };
    this.search.emit(search);
  }

  clean(): void {
    this.categoriesControl.setValue('');
    this.search.emit({year: 0});
  }

  compareCategories(c1: Master, c2: Master): boolean {
    return (c1 && c2 && c1.id === c2.id);
  }

}
